(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["messenger-button"] && !Shopify.designMode) return;
  try {
    document.querySelector('button[data-messenger-button]')?.addEventListener('click', function () {
    Genesys('command', 'Database.set', {
      messaging: {
        customAttributes: {
          webmsg_brandcode: 'NU',
          webmsg_country: Shopify.country,
          webmsg_language: Shopify.locale,
        },
      },
    });
    Genesys('command', 'Messenger.open');
  });
  } catch(e) { console.error(e); }
})();

})();
